import { useQuery } from '@apollo/client/react';
import { DatePicker } from '@optools/components/datetime/date-picker';
import { GameSchedule } from '@optools/components/game-schedule';
import { dateSchema } from '@optools/schemas/date';
import { GET_LOGGER_SCHEDULE } from '@optools/services/operator-gateway/logger/queries';
import { Sport } from '@optools/services/operator-gateway/types/generated/graphql';
import { LoggerGameCard } from '@optools/tools/logger/components/logger-game-card';
import { createFileRoute, useNavigate, useSearch } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';

export const Route = createFileRoute('/_auth/logger/')({
  component: RouteComponent,
  validateSearch: zodValidator(dateSchema),
});

export function RouteComponent() {
  const { date } = useSearch({ from: '/_auth/logger/' });
  const navigate = useNavigate({ from: Route.fullPath });
  const handleDateChange = (newDate: string) => {
    return navigate({ search: (search) => ({ ...search, date: newDate }) });
  };

  const { data, loading } = useQuery(GET_LOGGER_SCHEDULE, {
    fetchPolicy: 'network-only',
    variables: { date, sports: [Sport.MLB] },
  });

  return (
    <GameSchedule
      loading={loading}
      render={(game) => <LoggerGameCard key={game.gamePk} date={date} game={game} />}
      schedule={data?.schedule}>
      <DatePicker date={date} setDate={handleDateChange} />
    </GameSchedule>
  );
}
